import React from 'react';
import { Grid } from '@material-ui/core';

import yup from '../../../utility/yup';
import {
  ItemForm,
  FormInput,
} from '../../../components';
import { useTitle } from '../../../hooks';
import { Loadable } from '../../../store/types';
import { Organization } from '../../../types/items';

type Props = {
  creatingMode?: boolean;
  record: Loadable<Organization>;
  onSubmit: (record: Organization) => void;
  getTitle?: (() => string);
};

const accountSchema = yup.object().shape({
  common_name: yup.string().required().trim(),
});

const AccountForm = ({
  creatingMode = false,
  record: { loading, data },
  getTitle = undefined,
  onSubmit,
}: Props) => {
  useTitle('Account');
  const canEdit = data?.permissions.can_edit || false;

  return (
    <ItemForm
      creatingMode={creatingMode}
      initialValues={data}
      validationSchema={accountSchema}
      onSubmit={onSubmit}
      loading={loading}
      editPermitted={Boolean(data?.permissions.can_edit)}
      enableReinitialize
      preventCancelChanges
      validateOnMount={false}
      validateOnBlur={false}
      validateOnChange
    >
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <FormInput
            label="Name"
            name="common_name"
            autoFocus
            getValueAfterInit={getTitle}
            disabled={!canEdit}
          />
        </Grid>
        <Grid item xs={12}>
          <FormInput
            label="Legal Name"
            name="legal_name"
            disabled={!canEdit}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <FormInput
            label="City"
            name="city"
            disabled={!canEdit}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <FormInput
            label="State"
            name="state"
            disabled={!canEdit}
          />
        </Grid>
        <Grid item xs={12}>
          <FormInput
            label="Website"
            name="web_site_URL"
            disabled={!canEdit}
          />
        </Grid>
        <Grid item xs={12}>
          <FormInput
            label="Summary"
            name="summary_statement"
            type="textarea"
            disabled={!canEdit}
            spellCheck
          />
        </Grid>
      </Grid>
    </ItemForm>
  );
};

export default AccountForm;
